export default __webpack_public_path__ + "static/media/banner-fran.f0feb935.png";